import { Card, Grid } from '@mui/material';
import { H5, H6 } from 'components/Typography';
import { customShadows } from 'theme/shadows';

const statsData = [
  {
    label: '총 회원 수',
    value: '1,466',
  },
  {
    label: '게시글',
    value: '2,466',
  },
  {
    label: '댓글',
    value: '5,789',
  },
  {
    label: '조회 수',
    value: '178,229',
  },
];

export default function StatsCards() {
  return (
    <Grid container spacing={2}>
      {statsData.map((stat, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <Card
            sx={{
              padding: '24px',
              borderRadius: '18px',
              boxShadow: customShadows.card,
              backgroundColor: '#ffffff',
              border: 'none',
            }}
          >
            <H6
              sx={{
                color: theme => theme.palette.text.mainBlue,
                fontWeight: 400,
                marginBottom: '4px',
              }}
            >
              {stat.label}
            </H6>
            <H5
              sx={{
                color: theme => theme.palette.primary.mainBlue,
                fontWeight: 700,
                fontSize: '24px',
              }}
            >
              {stat.value}
            </H5>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
